import React, { FC } from 'react';

export const WarningIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6762 16.4442C21.3395 17.5749 20.9512 19.0236 19.8089 19.6802C19.4441 19.8898 19.0298 20.0002 18.608 20.0002H5.39165C4.07078 20.0002 3 18.9404 3 17.6329C3 17.2154 3.11157 16.8053 3.32338 16.4442L9.93153 5.17924C10.5948 4.04858 12.0585 3.66421 13.2007 4.32072C13.5603 4.5274 13.8593 4.8233 14.0681 5.17924L20.6762 16.4442ZM12 8.00024C11.4477 8.00024 11 8.44796 11 9.00024V13.0002C11 13.5525 11.4477 14.0002 12 14.0002C12.5523 14.0002 13 13.5525 13 13.0002V9.00024C13 8.44796 12.5523 8.00024 12 8.00024ZM12 16.0002C11.4477 16.0002 11 16.448 11 17.0002C11 17.5525 11.4477 18.0002 12 18.0002C12.5523 18.0002 13 17.5525 13 17.0002C13 16.448 12.5523 16.0002 12 16.0002Z"
      fill="currentColor"
    />
  </svg>
);
